module.exports = __webpack_public_path__ + "static/media/main_slider_2.d799e863.jpg";